import React from 'react';
import { Link } from 'react-router-dom';
import OffCanvas from "../UI/OffCanvas";
import NavbarItem from "../../shared/Header/Navbar/NavbarItem";
import navbarData from "../../data/Navbar/navbar";

const MobileMenu = ({ contactHref = '/contact', contactIsExternal = false }) => {
    const basePath = process.env.PUBLIC_URL || '';

    return (
        <OffCanvas type="menu">
            <div className="res-mobile-menu">
                <div className="mobile-nav">
                    <NavbarItem navItems={navbarData} />
                </div>
                <div className="mobile-contact-btn">
                    {contactIsExternal ? (
                        <a
                            href={contactHref}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-navigation-menu-mobile"
                        >
                            Contact us
                        </a>
                    ) : (
                        <Link
                            to={`${basePath}${contactHref}`}
                            className="btn-navigation-menu-mobile"
                        >
                            Contact us
                        </Link>
                    )}
                </div>
            </div>
        </OffCanvas>
    );
};

export default MobileMenu;